const B_1 = [
    {
        title: '异常终止信息',
        path: '/bidding/projectflow/dingbiao/zbyczz/list'
    }
]

export default {
    path: 'zbyczz',
    component: () => import(/*webpackChunkName: 'bidding-ding-zbzz-zbyczz'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/bidding/views/project-flow/ding/zbzz/zbyczz/list'),
            meta: {
                title: '异常终止信息',
                bread: '/bidding/projectflow/dingbiao/zbyczz/list'
            },
        },
        {
            path:"form",
            component: () => import('@views/bidding/views/project-flow/ding/zbzz/zbyczz/form'),
            meta: {
                title: '添加异常终止信息',
                bread: '/bidding/projectflow/dingbiao/zbyczz/form'
            },
        },
        {
            path:"detail",
            component: () => import('@views/bidding/views/project-flow/ding/zbzz/zbyczz/detail'),
            meta: {
                title: '异常终止信息详情',
                bread: '/bidding/projectflow/dingbiao/zbyczz/detail'
            },
        },
    ]
}